import type { WorldModule } from '../module';

/** `current`: only the shown bike is loaded (the garage loads others on demand); `all`: every fleet model preloaded. */
export class FleetModule implements WorldModule {
  readonly id = 'fleet' as const;
  constructor(private readonly preloadAll: () => Promise<void>, private readonly dropOthers: () => void) {}
  async build(level: string): Promise<void> { if (level === 'all') await this.preloadAll(); }
  dispose(): void { this.dropOthers(); }
}
